@if (showGrid) {
  <app-display-card>
    <div class="row row-padding-bottom">
      <div class="col">
        <input
          type="text"
          class="form-control"
          placeholder="Search for anything..."
          (ngModelChange)="universalSearchChange($event)"
          [(ngModel)]="UniversalSearch.text"
        />
      </div>
      <div class="col-auto">
        @if (GridApi) {
          <button class="btn btn-outline h-100" (click)="resetAllFilters()">
            Reset result filters
          </button>
        }
      </div>
    </div>
    <ag-grid-angular
      style="width: 100%; height: 100%"
      class="ag-theme-alpine vive-grid"
      [class.vive-grid--filtered-empty]="showFilteredEmptyGrid"
      [overlayNoRowsTemplate]="noRowsOverlayTemplate"
      [suppressLoadingOverlay]="rowModelType === 'serverSide'"
      [blockLoadDebounceMillis]="
        rowModelType === 'serverSide' ? serverSideLoadDebounceMillis : 0
      "
      [columnDefs]="columnDefs"
      [getMainMenuItems]="getMainMenuItems"
      [suppressMenuHide]="true"
      [defaultColDef]="defaultColDef"
      [rowData]="rowData | async"
      [rowSelection]="rowSelectionType"
      [animateRows]="true"
      [rowModelType]="rowModelType"
      [groupDisplayType]="groupDisplayType"
      [suppressFieldDotNotation]="suppressFieldDotNotation"
      [sideBar]="sideBar"
      [getContextMenuItems]="GetContextMenuItems"
      [pagination]="pagination"
      [paginationPageSize]="paginationPageSize"
      [context]="context"
      [components]="components"
      [getRowId]="getRowId"
      [rowMultiSelectWithClick]="rowMultiSelectWithClick"
      [suppressRowClickSelection]="suppressRowClickSelection"
      [isRowSelectable]="isRowSelectable"
      [cellSelection]="cellSelection"
      [initialState]="initialState"
      (gridReady)="onGridReady($event)"
      (rowDataUpdated)="onRowDataUpdated($event)"
      (modelUpdated)="onModelUpdated($event)"
      (firstDataRendered)="onFirstDataRendered($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (rowSelected)="onRowSelected($event)"
      (newColumnsLoaded)="onNewColumnsLoaded($event)"
      (storeRefreshed)="storeRefreshed($event)"
      (filterChanged)="filterChanged($event)"
      (columnMoved)="columnMoved($event)"
      (sortChanged)="sortChanged($event)"
      (rowClicked)="gridRowClicked($event)"
    ></ag-grid-angular>
    <div class="row">
      <div class="col"></div>
      <div class="col-auto">
        <label>Row Count: {{ totalRowCount }}</label>
      </div>
    </div>
  </app-display-card>
}
